import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import './marketplace.css';
import Navigation from '../../components/navigation/Navigation';
import HeaderProfile from "../../components/HeaderProfile";
/*import { hideLoading, showLoading } from '../../store/loading-reducer';*/
import PortalAlert from '../../components/portalAlert/portalAlert';
import { formatDate } from "../../helpers/formatterHelper";
import { getMarketPlace, getMarketPlaceTypes } from '../../store/marketPlace/actions';
import { Scrollbar } from 'react-scrollbars-custom';
import Spinner from '../../assets/icon/spinner.svg';


export default function MarketPlace() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [filter, setFilter] = useState({ query: '', marketPlaceTypeIds: [], sort: 10, isMyList: false });
    const { marketPlaceList, marketPlaceTypesList } = useSelector(state => state.marketPlace);
    const [loading, setLoading] = useState(false);
    const [delayedLoading, setDelayedLoading] = useState(false);

    useEffect(() => {
        document.title = 'Market Place  | CWP Team Connect';
        dispatch(getMarketPlaceTypes());
    }, []);

    useEffect(() => {
        const fetchMarketPlaceList = async () => {
            try {
                setLoading(true);
                await dispatch(getMarketPlace(filter)).unwrap();
            } catch (error) {
                console.error("Failed to fetch marketplace list:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchMarketPlaceList();
    }, [filter, dispatch]);

    useEffect(() => {
        let timer;
        if (loading) {
            timer = setTimeout(() => setDelayedLoading(true), 2000);
        } else {
            setDelayedLoading(false);
        }

        return () => clearTimeout(timer);
    }, [loading]);


    const isAllSelected =
        marketPlaceTypesList.length > 0 &&
        filter.marketPlaceTypeIds.length === 0;

    const handleCheckboxChange = (e, typeId) => {
        const { checked } = e.target;
        const parsedTypeId = parseInt(typeId, 10);
        if (parsedTypeId === 0) {
            setFilter(prev => ({
                ...prev,
                marketPlaceTypeIds: [],
            }));
        } else {
            setFilter(prev => {
                const isAllSelected = prev.marketPlaceTypeIds.length === marketPlaceTypesList.length;
                if (isAllSelected) {
                    return {
                        ...prev,
                        marketPlaceTypeIds: [parsedTypeId],
                    };
                }
                const updatedIds = checked
                    ? [...prev.marketPlaceTypeIds, parsedTypeId]
                    : prev.marketPlaceTypeIds.filter(id => id !== parsedTypeId);

                return {
                    ...prev,
                    marketPlaceTypeIds: updatedIds,
                };
            });
        }
    };

    const [isOpen, setIsOpen] = useState(false);

    // Close on Escape key
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") setIsOpen(false);
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    return (
        <div className="directory-wrap news-wrap">
            <div className="drawer-menu-collapse-wrap"></div>
            <Navigation />
            <div className="events-page-wrap">
                <div className="page-inner events-inner">
                    <div className="profile-wrap-outer mobile-show">
                        <HeaderProfile />
                    </div>

                    <div className="events-content-scrollable-wrap">
                        <div className="inner-pages-alert">
                            <PortalAlert />
                        </div>
                        <div className="profile-wrap-outer">
                            <HeaderProfile />
                        </div>
                        <div className="events-header-wrap marketplace-header-wrap">
                            <div className="marketplace-column-wrap inline-tags">
                                <label className="marketplace-checkbox-label block active-check">
                                    <input
                                        className="marketplace-inline-checkbox"
                                        type="checkbox"
                                        value="0"
                                        checked={isAllSelected}
                                        onChange={(e) => handleCheckboxChange(e, 0)}
                                    />
                                    <span className="marketplace-check-label-txt">All</span>
                                    <span className="marketplace-checkmark"></span>
                                </label>
                                {marketPlaceTypesList && marketPlaceTypesList?.length > 0 ? (
                                    marketPlaceTypesList.map((marketPlaceType) => (
                                        <label key={marketPlaceType.id} className="marketplace-checkbox-label block">
                                            <input
                                                className="marketplace-inline-checkbox"
                                                type="checkbox"
                                                value={marketPlaceType.id}
                                                checked={filter?.marketPlaceTypeIds?.includes(marketPlaceType?.id)}
                                                onChange={(e) => handleCheckboxChange(e, marketPlaceType.id)}
                                            />
                                            <span className="marketplace-check-label-txt">{marketPlaceType.name}</span>
                                            <span className="marketplace-checkmark"></span>
                                        </label>
                                    ))
                                ) : (
                                    <p>No marketplace types available</p>
                                )}
                                <button className="rules-popup" onClick={() => setIsOpen(true) }>Rules of Conduct</button>
                            </div>

                            <div className="events-header-wrap-inner">
                                <div className="marketplace-title-wrapper">
                                    <h1 className="page-title marketplace-page-title">Marketplace</h1>
                                    <div className="marketplace-links-wrapper">
                                        <Link className="marketplace-listing-link" to={'/marketplacemylisting'}>My Listings</Link>
                                     
                                        <div className="marketplace-button-bar ml-0" onClick={() => navigate('/marketplacemylisting/create')}>
                                            <span className="marketplace-button-txt">Create a Listing</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="events-content-wrap marketpace-content-wrap">
                                    {delayedLoading && (
                                        <div className="loader-wrap">
                                            <div className="spinner-align-center">
                                                <p className="">Loading</p>
                                                <img src={Spinner} alt="spinner" />
                                            </div>
                                        </div>
                                    )}
                                    <div className="events-content-wrap-inner">
                                        <div className="events-listing-wrap marketplace-listing-wrap">
                                            {marketPlaceList && marketPlaceList.length > 0 ? (
                                                marketPlaceList.map((item, index) => {
                                                    const marketPlaceType = marketPlaceTypesList.find(
                                                        (marketPlaceType) => marketPlaceType.id === item.marketPlaceTypeId
                                                    );

                                                    return (
                                                        <a key={index} onClick={() => navigate('/marketplace-details/' + item.baseId)} className={`marketplace-listing-item ${item?.media?.length > 0 ? 'listing-item-img' : ''}`}>
                                                            {item?.media && item?.media.length > 0 && (
                                                                <span className="marketplace-img-holder">
                                                                    <img
                                                                        src={item?.media[0]?.mediaItem?.previewsrc}
                                                                        className="marketplace-img"
                                                                        alt={item?.media[0]?.mediaItem?.altText || "marketplace item"}
                                                                        loading="lazy"
                                                                    />
                                                                </span>
                                                            )}
                                                            <span className="marketplace-top-info-wrap">
                                                                <span className="marketplace-pill-item">{marketPlaceType?.name}</span>
                                                                <span className="marketplace-value">
                                                                    <span className="marketplace-value">  {item?.amountInfo}
                                                                        {item?.amountType &&
                                                                            <span className="marketplace-value-desc amount-type">{item?.amountType}</span>
                                                                        }
                                                                    </span>
                                                                </span>
                                                            </span>

                                                            <span className="marketplace-information-wrap">
                                                                <span className="marketplace-information-inner">
                                                                    <span className="marketplace-title-wrap">{item?.title}</span>
                                                                    <span className="marketpalce-desc-wrap"></span>
                                                                </span>
                                                                <span className="marketplace-info-wrap">
                                                                    <span className="marketplace-date">{formatDate(item?.publishDate, "MMM dd")}</span>
                                                                    <span className="marketplace-location">{item?.location}</span>
                                                                </span>
                                                            </span>
                                                        </a>
                                                    );
                                                })
                                            ) : (
                                                <p>No marketplace items available</p>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {isOpen && (
                
                <div
                    className="rule-conduct-overlay"
                    onClick={() => setIsOpen(false)} // Close when clicking outside
                >
                    
                    
                        <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                            <div className="popup-close-wrap">
                                <button
                                    onClick={() => setIsOpen(false)}
                                    className="popup-close"
                                >
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.00036 5.79037L1.19553 9.59518C1.09169 9.69903 0.961168 9.75215 0.803956 9.75455C0.646756 9.75697 0.513831 9.70384 0.405181 9.59518C0.296519 9.48653 0.242188 9.3548 0.242188 9.2C0.242188 9.04521 0.296519 8.91348 0.405181 8.80483L4.20999 5L0.405181 1.19518C0.301331 1.09134 0.248206 0.960818 0.245806 0.803605C0.243394 0.646405 0.296519 0.51348 0.405181 0.40483C0.513831 0.296168 0.645556 0.241837 0.800356 0.241837C0.955156 0.241837 1.08688 0.296168 1.19553 0.40483L5.00036 4.20964L8.80518 0.40483C8.90902 0.30098 9.03954 0.247855 9.19675 0.245455C9.35395 0.243043 9.48688 0.296168 9.59553 0.40483C9.70419 0.51348 9.75852 0.645205 9.75852 0.800005C9.75852 0.954805 9.70419 1.08653 9.59553 1.19518L5.79072 5L9.59553 8.80483C9.69938 8.90867 9.7525 9.03919 9.7549 9.19641C9.75732 9.35361 9.70419 9.48653 9.59553 9.59518C9.48688 9.70384 9.35515 9.75817 9.20035 9.75817C9.04555 9.75817 8.91383 9.70384 8.80518 9.59518L5.00036 5.79037Z" fill="currentColor" />
                                    </svg>
                                </button>
                            </div>
                        <Scrollbar
                            wrapperProps={{ className: 'custom-scrollbar-wrapper' }}
                            thumbMinSize={30}
                            trackYProps={{ className: 'custom-scrollbar-track-y' }}
                            thumbYProps={{ className: 'custom-scrollbar-thumb-y' }}
                        >
                            <h2 className="popup-window-headline">Marketplace Rules of Conduct</h2>
                            <div className="popup-content-item">
                                <p className="popup-content-rule">Respectful Behavior</p>
                                <ul className="popup-content-item-list">
                                    <li>All users must treat others with respect, fairness, and courtesy.</li>
                                    <li>Harassment, discrimination, hate speech, and any offensive behavior will not be tolerated.</li>
                                    <li>Any form of abusive language or behavior that disrupts the community will result in suspension or banning from the platform.</li>
                                </ul>
                            </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Accurate Listings</p>
                                    <ul className="popup-content-item-list">
                                        <li>Sellers must ensure that all product listings are accurate, truthful, and not misleading in any way.</li>
                                        <li>Any claims about the product must be substantiated with verifiable information.</li>
                                        <li>No false advertising or misrepresentation of products or services.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Intellectual Property</p>
                                    <ul className="popup-content-item-list">
                                        <li>Users must respect intellectual property rights. Do not list, sell, or share counterfeit, pirated, or stolen goods.</li>
                                        <li>Only list products you have the right to sell, and ensure that all content (including photos, descriptions, and brand names) is your own or properly licensed.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Fair Transactions</p>
                                    <ul className="popup-content-item-list">
                                        <li>Buyers and sellers must honor all agreements, including prices, delivery dates, and payment methods.</li>
                                        <li>All payments should be made through the platform&apos;s official channels to ensure protection and proper documentation.</li>
                                        <li>Any attempt to circumvent the platform&apos;s payment system is strictly prohibited.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Prohibited Items</p>
                                    <ul className="popup-content-item-list">
                                        <li>The sale or trade of illegal, harmful, dangerous, or prohibited items is not allowed.</li>
                                        <li>This includes, but is not limited to, weapons, drugs, counterfeit goods, and stolen merchandise.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Privacy and Confidentiality</p>
                                    <ul className="popup-content-item-list">
                                        <li>Users must not share personal information of other users without consent.</li>
                                        <li>Respect the privacy of all participants, and ensure that any communication is appropriate for the marketplace environment.</li>
                                        <li>Do not attempt to collect or misuse personal data.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Product Quality and Refunds</p>
                                    <ul className="popup-content-item-list">
                                        <li>Sellers must offer goods in the condition described in their listings and comply with any guarantees or warranties offered.</li>
                                        <li>Buyers have the right to request refunds or returns in accordance with the marketplace&apos;s return policy if the product does not meet the description or is defective.</li>
                                        <li>Both buyers and sellers must engage in good faith when resolving disputes.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">No Fraudulent Activity</p>
                                    <ul className="popup-content-item-list">
                                        <li>Fraudulent activities, including scam listings, fake reviews, chargebacks, or any kind of deceptive behavior, will result in immediate account suspension and potential legal action.</li>
                                        <li>Sellers must not manipulate ratings or feedback systems.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Communication</p>
                                    <ul className="popup-content-item-list">
                                        <li>Communication between buyers and sellers should be polite and professional.</li>
                                        <li>Refrain from spamming other users or sending unsolicited messages.</li>
                                        <li>Use the platform&apos;s messaging system for all communications related to transactions.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Compliance with Local Laws</p>
                                    <ul className="popup-content-item-list">
                                        <li>Users must comply with all applicable local, state, and international laws, including import/export regulations, consumer protection laws, and tax requirements.</li>
                                        <li>Sellers are responsible for understanding the legalities of shipping items to different regions or countries.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Account Security</p>
                                    <ul className="popup-content-item-list">
                                        <li>Users are responsible for the security of their accounts and must keep login credentials confidential.</li>
                                        <li>Report any suspicious activity or unauthorized transactions immediately to the platform administrators.</li>
                                        <li>It is recommended to use strong passwords and enable two-factor authentication when available.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Platform Integrity</p>
                                    <ul className="popup-content-item-list">
                                        <li>Users are prohibited from attempting to exploit, hack, or disrupt the functionality of the platform in any way.</li>
                                        <li>Any manipulation of the marketplace algorithms, including attempting to artificially inflate product rankings, is forbidden.</li>
                                    </ul>
                                </div>
                                <div className="popup-content-item">
                                    <p className="popup-content-rule">Enforcement</p>
                                    <ul className="popup-content-item-list">
                                        <li>The platform reserves the right to take action, including warnings, suspension, or permanent bans, for violations of these rules.</li>
                                        <li>Serious violations, including fraud, illegal activity, or abusive behavior, may result in legal action.</li>
                                    </ul>
                                </div>

                            </Scrollbar>  
                            
                        </div>
                    
                    </div>
                
            )}
        </div>
    );
}